// extracted by mini-css-extract-plugin
module.exports = {"loadingGrid":"assessmentFull_loadingGrid__7Lut0","loadingText":"assessmentFull_loadingText__1p3Pc"};